"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _FeedbackContainerNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/FeedbackContainerNugget"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _KESI2Helper = require("../../../../KESI2/KESI2Helper");

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _DrupalNugget = _interopRequireDefault(require("../../../../../targets/cord_sanofi/DrupalNugget.js"));

var _index = _interopRequireDefault(require("../../Button/index"));

var _DrupalNuggetStrings = require("./DrupalNuggetStrings");

var _DrupalFeedbackContainerNugget = _interopRequireDefault(require("./DrupalFeedbackContainerNugget.scss"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DrupalFeedbackNugget = _interopRequireDefault(require("./DrupalFeedbackNugget"));

var _MailHelper = require("../../../../helpers/MailHelper");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _UserManagementService = _interopRequireDefault(require("../../Equizzer/services/UserManagementService"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'feedbackcontainerContainer_';

var DrupalFeedbackContainerNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalFeedbackContainerNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalFeedbackContainerNugget);

  function DrupalFeedbackContainerNugget(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrupalFeedbackContainerNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "asyncForEach", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(array, callback) {
        var index;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                index = 0;

              case 1:
                if (!(index < array.length)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return callback(array[index], index, array);

              case 4:
                index++;
                _context.next = 1;
                break;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onClick", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var nugget, feedbackData, voteData, getData, toArray, ccArray, bccArray, userMail, userData, feedbackMessage, voteMessage, userEmail, message;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              nugget = _this.getNugget();
              feedbackData = [];
              voteData = [];

              getData = /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                  return _regenerator["default"].wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _this.asyncForEach(_this.listeners, /*#__PURE__*/function () {
                            var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(listener) {
                              var nuggetData, voteString;
                              return _regenerator["default"].wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      _context2.next = 2;
                                      return listener.fp();

                                    case 2:
                                      nuggetData = _context2.sent;

                                      if (nuggetData && nuggetData.type === 'feedback') {
                                        if (nuggetData.data && nuggetData.data.value) {
                                          feedbackData.push("".concat(nuggetData.data.title, "<br/><br/>Feedback: ").concat(nuggetData.data.value, "<br/><br/>"));
                                        }
                                      } else if (nuggetData && nuggetData.type === 'vote') {
                                        if (nuggetData.data) {
                                          voteString = "Votingergebnisse f\xFCr die Frage \"".concat(nuggetData.question, "\":<br/><br/>Gew\xE4hlte Antwort des Users: ").concat(nuggetData.userAnswer, "<br/><br/>");
                                          nuggetData.data.forEach(function (answer) {
                                            voteString += "".concat(answer.text, ": ").concat(_config["default"].absoluteVoteResults ? "".concat(answer.Stimmen, " Stimmen") : "".concat(answer.Prozent, " Prozent"), "<br/><br/>");
                                          });
                                          voteData.push(voteString);
                                        }
                                      }

                                    case 4:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2);
                            }));

                            return function (_x3) {
                              return _ref4.apply(this, arguments);
                            };
                          }());

                        case 2:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function getData() {
                  return _ref3.apply(this, arguments);
                };
              }();

              _context4.next = 6;
              return getData();

            case 6:
              if (!(feedbackData.length === 0 && voteData.length === 0)) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("return", (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalNuggetStrings.getString)('FEEDBACK_ENTER_TEXT'), (0, _DrupalNuggetStrings.getString)('FEEDBACK_ENTER_TITLE')));

            case 8:
              toArray = nugget.feedbackEmail ? nugget.feedbackEmail.split(',') : [];
              ccArray = nugget.feedbackEmailCC ? nugget.feedbackEmailCC.split(',') : [];
              bccArray = nugget.feedbackEmailBCC ? nugget.feedbackEmailBCC.split(',') : [];

              if (!(nugget.sendToUser && _config["default"].userEmailPath)) {
                _context4.next = 24;
                break;
              }

              userMail = _DataStore["default"].getElementByPathImmediately(_config["default"].userEmailPath);

              if (userMail) {
                _context4.next = 23;
                break;
              }

              _context4.next = 16;
              return _UserManagementService["default"].getUserFromAuthServer();

            case 16:
              userData = _context4.sent;

              if (!(userData && userData.user && userData.user.additionalData)) {
                _context4.next = 21;
                break;
              }

              _context4.next = 20;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.USER_PROFILE, userData.user.additionalData);

            case 20:
              return _context4.abrupt("return", _this.onClick());

            case 21:
              _context4.next = 24;
              break;

            case 23:
              toArray.push(userMail);

            case 24:
              // TODO: send all this stuff via email to all given email adresses in the feedback data
              feedbackMessage = feedbackData && feedbackData.length > 0 ? '<b>Freitextfeedback:</b><br/><br/>' + feedbackData.join('<br/><br/>') : '';
              voteMessage = voteData && voteData.length > 0 ? '<b>Abstimmungsergebnisse:</b><br/><br/>' + voteData.join('<br/><br/>') : '';
              userEmail = _this.state.emailValue ? '<b>User E-Mail: ' + _this.state.emailValue + '</b>' : '';
              message = feedbackMessage + '<br/><br/>' + voteMessage + '<br/><br/>' + userEmail;
              console.log('send container mail to', feedbackMessage, voteMessage, userEmail, message);

              _this.reallySendMail(toArray, null, ccArray, bccArray, message);

            case 30:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "reallySendMail", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(toArray, from, ccArray, bccArray, message) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return (0, _MailHelper.sendFeedbackMail)(toArray, from, ccArray && ccArray.length > 0 ? ccArray : null, bccArray && bccArray.length > 0 ? bccArray : null, "".concat(_config["default"].defaultNavbarTitle, " Feedback"), message);

              case 3:
                (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalNuggetStrings.getString)('FEEDBACK_THANKS_TEXT'), null, false);

                _this.setState({
                  emailValue: ''
                });

                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalNuggetStrings.getString)('FEEDBACK_ERROR_TEXT'), (0, _DrupalNuggetStrings.getString)('FEEDBACK_ERROR_TEXT', [_context5.t0]));

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 7]]);
      }));

      return function (_x4, _x5, _x6, _x7, _x8) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "registerSendFunc", function (id, fp) {
      _this.listeners.push({
        id: id,
        fp: fp
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (event) {
      if (event && event.target && event.target.value && event.target.value !== '') {
        _this.setState({
          emailValue: event.target.value
        });
      }
    });
    _this.state = _objectSpread({
      value: '',
      emailValue: ''
    }, _this.state);
    _this.listeners = [];

    _this.props.registerNugget(_this.props.id, _FeedbackContainerNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    _this.setDataStorePaths([_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);

    return _this;
  }

  (0, _createClass2["default"])(DrupalFeedbackContainerNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _FeedbackContainerNugget["default"].CLASS, this.getDomId()); // this.getIcsContents()

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }
    }
  }, {
    key: "getNugget",
    value: function getNugget() {
      return this.state.content[this.props.id];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var nugget = this.getNugget();
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "feedbackcontainerContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: {
          margin: '2% auto',
          backgroundColor: '#ededed',
          padding: '20px 0'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalFeedbackContainerNugget["default"].feedbackcontainerInnerContainer
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", null, nugget.contents.map(function (nuggetToMap, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: nuggetToMap.id
        }, /*#__PURE__*/_react["default"].createElement(_DrupalNugget["default"], {
          id: nuggetToMap.id,
          path: _this2.props.path,
          registerNugget: _this2.props.registerNugget,
          markAsRead: _this2.props.markAsRead,
          contentPathArray: _this2.props.contentPathArray,
          inFeedbackContainer: true,
          registerSendFunc: _this2.registerSendFunc
        }));
      }), nugget.showEmailField ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: 'calc(80% - 40px)',
          margin: '0 auto'
        }
      }, /*#__PURE__*/_react["default"].createElement("p", null, (0, _DrupalNuggetStrings.getString)('FEEDBACK_EMAIL_INFO')), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        value: this.state.emailValue,
        margin: 'normal',
        rows: 3,
        InputProps: {
          disableUnderline: true
        },
        classes: {
          root: _DrupalFeedbackContainerNugget["default"].feedbackTextfield
        },
        onChange: this.handleChange
      })) : null), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalFeedbackContainerNugget["default"].buttonContainer
      }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
        forcedColor: _config["default"].useTileBackgroundColorInTile ? this.props.forcedUIColor : _cssConstants["default"].colors.buttonBackground,
        className: _config["default"].useCenteredButtons ? _DrupalFeedbackContainerNugget["default"].centeredButton : _DrupalFeedbackContainerNugget["default"].button,
        onClick: function onClick() {
          return _this2.onClick();
        }
      }, nugget.sendToUser ? (0, _DrupalNuggetStrings.getString)('SEND_NOTES_TO_ME_NOW') : (0, _DrupalNuggetStrings.getString)('SEND_NOW')))));
    }
  }]);
  return DrupalFeedbackContainerNugget;
}(_KESI2BasicComponent["default"]);

DrupalFeedbackContainerNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired
};
_DrupalFeedbackNugget["default"].defaultProps = {
  id: null
};
var _default = DrupalFeedbackContainerNugget;
exports["default"] = _default;